import React from 'react';

interface PreloaderProps {
  isLoading: boolean;
}

const Preloader: React.FC<PreloaderProps> = ({ isLoading }) => {
  return (
    <div className={`preload ${!isLoading ? 'loaded' : ''}`} data-preaload>
      <div className="circle"></div>
      <p className="text">Happy Valley Village</p>
    </div>
  );
};

export default Preloader;
